<div class="containeer-fluid">
  <div class="row">
    <div class="col-md-12 mb-1">
      <div class="breadcrumb-title border-0 pe-3">
        <app-list-header
          [title]="'Support List'"
          icon="bi bi-window-stack"
          [$parent]="getSelf()"
        >
        </app-list-header>
      </div>
    </div>

    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <form class="row gx-2 gy-2 align-items-center">
            <div class="col-12 col-md-6 col-lg-2 ms-1">
              <input
                id="title"
                name="title"
                placeholder="Title"
                type="text"
                class="form-control form-control-sm"
                [(ngModel)]="form.searchParams['title']"
              />
            </div>
            <ng-container *ngFor="let e of attributeList">
              <div
                *ngIf="e['type'] === 'list'  && (e['code']==='category' || e['code']==='status') "
                class="col-12 col-md-6 col-lg-2 ms-1"
              >
                <select
                  [(ngModel)]="form.searchParams[e.code]"
                  class="form-select form-select-sm"
                  id="{{ e.code }}"
                  name="{{ e.code }}"
                  [ngClass]="{
                    'placeholder-grey': form.searchParams[e.code] === undefined
                  }"
                >
                  <option selected [value]="undefined">
                    --Select {{ e.label }}--
                  </option>
                  <option *ngFor="let c of e['values']" value="{{ c }}">
                    {{ c }}
                  </option>
                </select>
              </div>
            </ng-container>
            <div class="col-12 col-md-6 col-lg-2 ms-1">
              <input
                id="description"
                name="description"
                placeholder="Description"
                type="text"
                class="form-control form-control-sm me-2"
                [(ngModel)]="form.searchParams['description']"
              />
            </div>
            <div class="col-auto">
              <button
                (click)="search()"
                class="btn btn-outline-primary btn-sm"
                title="Search"
              >
                <i class="fa fa-search-plus"></i> Search
              </button>
            </div>
            <div class="col-auto">
              <button
                (click)="resetSearchForm()"
                class="btn btn-outline-primary btn-sm"
                id="marginSet"
                title="Reset"
              >
                <i class="fa fa-eraser" aria-hidden="true"></i>
              </button>
            </div>

            <div class="col-auto">
              <button
                data-bs-toggle="modal"
                data-bs-target="#editModal"
                (click)="get(0)"
                class="btn btn-outline-primary btn-sm"
                title="Add"
              >
                <i class="fa fa-plus"></i> Add
              </button>
            </div>
          </form>

          <div class="tab-content" id="pills-tabContent">
            <!-- table form -->
            <div class="table-responsive mt-3 mb-3">
              <p *ngIf="form['searchError'] == false && form['searchMessage']">
                <app-ncs-alert
                  [message]="form['searchMessage']"
                  type="success"
                />
              </p>
              <p *ngIf="form['searchError'] == true && form['searchMessage']">
                <app-ncs-alert
                  [message]="form['searchMessage']"
                  type="danger"
                />
              </p>
              <table class="table table-sm table-striped my-1">
                <thead >
                  <tr>
                    <th>S.No.</th>
                    <th>Title</th>
                    <th>Category</th>
                    <th>Status</th>
                    <th>Description</th>
                  
                  </tr>
                  <tr>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let e of form.list; let i = index">
                    <td>{{ pageIndex(i) }}</td>
                    <td [title]="e['title']">{{ e["title"] | truncate }}</td>
                    <td>{{ e["category"] }}</td>
                    <td>{{ e["status"] }}</td>
                    <td [title]="e['description']">
                      {{ e["description"] }}
                    </td>
                   
                  </tr>
                </tbody>
              </table>
              <app-list-header [$parent]="getSelf()"></app-list-header>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- data entry form -->
<div class="modal fade" id="editModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Support</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          title="Close"
        ></button>
      </div>

      <div class="modal-body">
        <form class="px-3 mb-2" #uiForm="ngForm">
          <!-- Error / Success Message -->
          <p *ngIf="form['error'] == false && form['message']">
            <app-ncs-alert [message]="form['message']" type="success" />
          </p>
          <p *ngIf="form['error'] == true && form['message']">
            <app-ncs-alert [message]="form['message']" type="danger" />
          </p>
          <div class="row mb-3">
            <div class="col-sm-3">
              <label for="title" class="h6 form-label">Title</label>
            </div>
            <div class="col-sm-9 text-secondary">
              <input
                required
                [(ngModel)]="form.data['title']"
                name="title"
                type="text"
                class="form-control form-control-sm"
                id="title"
                placeholder="Enter Title "
              />
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3">
              <label for="category" class="h6 form-label">Category</label>
            </div>
            <ng-container *ngFor="let e of attributeList">
              <div *ngIf="e['type'] === 'list' && e.code==='category'" class="col-sm-9 text-secondary">
                <select
                  required="{{ e['required'] == 1 }}"
                  [(ngModel)]="form.data[e.code]"
                  class="form-select form-select-sm"
                  id="{{ e.code }}"
                  name="{{ e.code }}"
                >
                  <option selected [value]="undefined">
                    --Select {{ e.label }} --
                  </option>
                  <option *ngFor="let c of e['values']" value="{{ c }}">
                    {{ c }}
                  </option>
                </select>
              </div>
            </ng-container>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3">
              <label for="description" class="h6 form-label">Description</label>
            </div>
            <div class="col-sm-9 text-secondary">
              <textarea
                required
                [(ngModel)]="form.data['description']"
                type="text"
                class="form-control form-control-sm readonly-field"
                id="description"
                name="description"
                placeholder=" Enter Description"
              ></textarea>
            </div>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button
          title="Save"
          class="btn btn-outline-primary btn-sm ml-2"
          [disabled]="!uiForm.valid"
          (click)="saveSupport()"
        >
          <i class="fa fa-save"></i> Save
        </button>
        <button
          type="button"
          class="btn btn-outline-secondary btn-sm ml-2"
          data-bs-dismiss="modal"
          title="Close"
        >
          <i class="fa fa-window-close"></i> Close
        </button>
      </div>
    </div>
  </div>
</div>
